<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link } from "svelte-routing";
	import PageHeader from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Simuladores Financeiros';

	let simuladores = [
		{
			title: 'Simulador de Financiamento - Caixa',
			image: 'caixa.png',
			link: 'http://www8.caixa.gov.br/',
		},
		{
			title: 'Simulador de Financiamento - Banrisul',
			image: 'banrisul.png',
			link: 'https://www.banrisul.com.br/brz/link/brzwswhn.html?secao_id=1083',
		},
		{
			title: 'Simulador de Financiamento - Banco Do Brasil',
			image: 'bancoDoBrasil.png',
			link: 'https://www.bb.com.br/pbb/pagina-inicial/voce/produtos-e-servicos/financiamentos/bb-credito-imobiliario?gclid=Cj0KCQiAtqL-BRC0ARIsAF4K3WG8IYKMtBjE0GUVclTz-8nJoQ5ADdmf68K0pN8G6n3Q2L5TH0ryuxkaApkEEALw_wcB#/',
		},
		{
			title: 'Simulador de Financiamento - Bradesco',
			image: 'bradesco.png',
			link: 'https://banco.bradesco/html/classic/produtos-servicos/emprestimo-e-financiamento/encontre-seu-credito/simuladores-imoveis.shtm',
		},
		{
			title: 'Simulador de Financiamento - Santander',
			image: 'santander.png',
			link: 'https://www.santander.com.br/atendimento-para-voce/simuladores/simulador-credito-imobiliario',
		},
		{
			title: 'Simulador de Financiamento - Itaú',
			image: 'itau.png',
			link: 'https://www.itau.com.br/emprestimos-financiamentos/credito-imobiliario/simulador?utm_source=google&utm_medium=&utm_campaign=vs-pf-cicimcri-iacrim-conv-credimob_m&utm_content=af003-google-gog-ca027-fss-cpa-cros-audi-financ-nd-inse-vscicim00300&dclid=CjkKEQjw_NX7BRCDpPS3sqb78OYBEiQAFxG9EgKdCk-ObMQC38KNJdRBfox1LbOkoFevDg77qASncCbw_wcB&ef_id=Cj0KCQiAtqL-BRC0ARIsAF4K3WH0KHHjNgKyDiWD149r0F6MS9kuEm3xjUtgyirKKHEpemTsRa1rMCoaAtoHEALw_wcB:G:s&s_kwcid=AL!905!3!466882955005!b!!g!!financiamento%20imobili%C3%A1rio%20ita%C3%BA%20simulador%5D&gclid=Cj0KCQiAtqL-BRC0ARIsAF4K3WH0KHHjNgKyDiWD149r0F6MS9kuEm3xjUtgyirKKHEpemTsRa1rMCoaAtoHEALw_wcB',
		},
	];
</script>

<PageHeader title={titlePage}></PageHeader>

<div class="container clearfix">
	<p class="text-justify">Clique sobre o banco de sua preferência para ter acesso ao simulador de financiamento correspondente.</p>
	<ul class="list flex-grid mt-30">
		{#each simuladores as simulador}
			<li class="item">
				<a href={simulador.link} title="Ir para {simulador.title}" target="_blank">
					<img class="image img-fluid mb-20 mr-10 ml-10" src="/assets/images/bancos/{simulador.image}" alt="Logo {simulador.title}" width="200" height="auto">
				</a>
			</li>
		{/each}
	</ul>        
</div>
